/**
 * Filters a schedule object to only include lessons matching the given location ID.
 *
 * @param {object} schedule - The full schedule response from the API ({ objects: { [hour]: lesson[] } })
 * @param {number|null} locationId - The location ID to filter by, or null to return all lessons
 * @returns {object} A new schedule object with the same shape but only matching lessons
 */
export const filterScheduleByLocationId = (schedule, locationId) => {
  if (!schedule || !schedule.objects) return schedule;
  if (locationId === null || locationId === undefined) return schedule;

  const filteredObjects = {};

  Object.keys(schedule.objects).forEach((hourKey) => {
    const hourLessons = schedule.objects[hourKey];

    if (!Array.isArray(hourLessons)) {
      // null slots (gaps) — omit in filtered view
      return;
    }

    const matching = hourLessons.filter(
      (lesson) => lesson.lesson_type?.location?.id === locationId
    );

    if (matching.length > 0) {
      filteredObjects[hourKey] = matching;
    }
  });

  return {
    ...schedule,
    objects: filteredObjects,
    num_results: Object.keys(filteredObjects).length,
  };
};
